import * as React from "react";
import { Path, Rect, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const BHIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="BH" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path fill="#E31D1C" d="M0 0h16v12H0z" />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0h3.4L6 1 3.4 2 6 3 3.4 4 6 5 3.4 6 6 7 3.4 8 6 9l-2.6 1L6 11l-2.6 1H0V0Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
